import { Card, CardBody, Col } from "reactstrap";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SlideOnly } from "../../../../Constant";
import { SLIDES_ONLY, SLIDES_ONLY_DATA } from "../../../../Data/Bonus Ui/Carousel";

const SlidesOnly = () => {
  return (
    <Col xl="6" sm="12">
      <Card>
        <CommonCardHeader title={SlideOnly} span={SLIDES_ONLY} />
        <CardBody>
          <Swiper centeredSlides={true} autoplay={{ delay: 2500, disableOnInteraction: false }} modules={[Autoplay]}>
            {SLIDES_ONLY_DATA.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={item.image} alt="drawing-room" className="d-block w-100" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SlidesOnly;
